import {
  VStack,
  Image,
  getCdnImageSrc,
  colors,
  Spacing,
  Button,
  responsive,
} from "goi_common";

import { Box } from "@chakra-ui/react";

import { ReactNode } from "react";

export const DEFAULT_BACKGROUND_COLOR = "#74706F";

interface HomeV4HeroSectionProps {
  title?: ReactNode;
  description?: string;
  imageSrc?: string;
  buttonText?: string;
  background?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export default function HomeV4HeroSection({
  title = `지금 시작하면\n장례 비용 평생 보장`,
  description = "우리 가족을 위한 최고의 선택, 고이 상조",
  imageSrc = getCdnImageSrc("direct/home/money_shield_concept.png"),
  buttonText = "시작하기",
  background = DEFAULT_BACKGROUND_COLOR,
  onClick,
  disabled = false,
}: HomeV4HeroSectionProps) {
  return (
    <VStack
      background={background}
      width="100%"
      overflow="hidden"
      alignItems="center"
      position="relative"
      css={responsive({
        /** 상단 메뉴바 반응형 고려 padding 조정 */
        padding: { base: "80px 0 40px", md: "56px 0 40px" },
      })}
    >
      <Box
        textAlign="center"
        className="head_32_b"
        color={colors.white}
        whiteSpace="pre-line"
      >
        {title}
      </Box>
      <Spacing gap={16} />
      <Box
        textAlign="center"
        className="subtitle_16_sb"
        color={colors.white}
        whiteSpace="pre-wrap"
      >
        {description}
      </Box>

      <Box width="300px" margin="24px 0">
        <Image src={imageSrc} width="100%" height="auto" alt="가격 보장" />
      </Box>

      <Button
        className="body_16_m"
        onClick={onClick}
        css={{
          border: "1px solid white",
          borderRadius: "6px",
          background: colors.white,
          color: disabled ? colors.gray300 : colors.gray900,
          padding: "12px 24px",
        }}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </VStack>
  );
}
